import { FunctionComponent } from 'react';
import { Minus, Plus } from '@/icons';
import { oneLine } from 'common-tags';
import { TypeQuantityProps } from './types';

export const Quantity: FunctionComponent<TypeQuantityProps> = ({
  name,
  className = '',
  disabled = false,
  min = 0,
  max = 99,
  type = 'button',
  onClick,
  initialValue
}: TypeQuantityProps) => (
  <div
    className={oneLine`
    flex justify-center items-center w-[100px] h-10 p-2 border-solid border-y border-secondary-200 select-none
    ${className}
  `}
    aria-disabled={disabled}
  >
    <div className="flex flex-row gap-2">
      <button
        disabled={initialValue <= min || disabled}
        onClick={() => {
          onClick && onClick(initialValue - 1)
        }}
        className={oneLine`
            text-primary-600 appearance-none rounded-full transition-colors
            disabled:cursor-not-allowed
            enabled:hover:text-primary-500 enabled:active:text-text-alternative enabled:active:bg-primary-500
            ${disabled ? "" : "disabled:opacity-40"}
          `}
        type={type}
      >
        <Minus width={24} />
      </button>

      <input
        type="number"
        value={initialValue}
        readOnly
        name={name}
        className="w-5 text-center text-text-primary p-0 select-none appearance-none cursor-default spin-button-none border-0 focus:ring-transparent focus:ring-offset-0"
        min={min}
        max={max}
      />

      <button
        disabled={initialValue >= max || disabled}
        onClick={() => {
          onClick && onClick(initialValue + 1)
        }}
        className={oneLine`
            text-primary-600 appearance-none rounded-full transition-colors
            disabled:cursor-not-allowed
            enabled:hover:text-primary-500 enabled:active:text-text-alternative enabled:active:bg-primary-500
            ${disabled ? "" : "disabled:opacity-40"}

          `}
        type={type}
      >
        <Plus width={24} />
      </button>
    </div>
  </div>
);

Quantity.displayName = 'Quantity';
